import NewSuggestion from "../../components/NewSuggestion/NewSuggestion";

const NewSuggestionPage = () => {
  return <NewSuggestion />;
};

export default NewSuggestionPage;
